module.exports = __webpack_public_path__ + "img/moveIcon.0ab09eee.png";